import { DropdownButton, Flex, Text } from "@jsq/ds/core";
import { Icon } from "@jsq/ds/icons";
import { Sizes } from "@jsq/ds/styles";
import { ComplianceCaseTypeEnum as CaseTypeEnum } from "~/graphql/supergraphEnums";
import { type ComplianceCaseTypeEnum } from "~/graphql/supergraphTypes";
import { SPACING } from "~/styles/variables";
import { type DocumentActionsValue } from "../types";

export type DeleteDocumentInfo = {
  documentId: number;
  documentName: string;
  documentUrl: string;
  profileId: number | null;
  baseType: DocumentActionsValue["baseType"];
};

type Props = {
  documentInfo: DocumentActionsValue;
  readonly: boolean;
  caseType?: ComplianceCaseTypeEnum;
  docIdsLinkedToCase?: number[];
  onDeleteClick: (info: DeleteDocumentInfo) => void;
};

export const DocumentActions = ({
  documentInfo,
  readonly,
  caseType,
  docIdsLinkedToCase,
  onDeleteClick,
}: Props) => {
  const documentId = documentInfo.id;
  const documentName = documentInfo.name;
  const documentUrl = documentInfo.s3Link;

  const disableDeleteAction: boolean =
    caseType === CaseTypeEnum.RecurringHit || caseType === CaseTypeEnum.Escalation
      ? !docIdsLinkedToCase?.includes(documentInfo.id)
      : false;

  const deleteAction = () => {
    onDeleteClick({
      documentId,
      documentName,
      documentUrl,
      profileId: documentInfo.profileId,
      baseType: documentInfo.baseType,
    });
  };

  const downloadAction = () => {
    window.open(documentUrl);
  };

  return (
    <DropdownButton
      data-testid={`document-${documentId}-actions`}
      css={{ margin: SPACING.X_SMALL }}
      variant="muted"
      icon="ellipsis-h"
      direction="down"
      align="right"
      usePortal
    >
      <DropdownButton.Action disabled={readonly || disableDeleteAction} onSelect={deleteAction}>
        <Flex alignItems="center" gap={Sizes.XS} css={{ height: "100%" }}>
          <Icon type="trash" />
          <Text>Delete</Text>
        </Flex>
      </DropdownButton.Action>
      <DropdownButton.Action disabled={readonly} onSelect={downloadAction}>
        <Flex alignItems="center" gap={Sizes.XS} css={{ height: "100%" }}>
          <Icon type="download" />
          <Text>Download</Text>
        </Flex>
      </DropdownButton.Action>
    </DropdownButton>
  );
};
